import React from 'react';

const Toast = ({ show, message }) => {
  if (!show) return null;

  return (
    <div
      className="toast"
      style={{
        opacity: show ? 1 : 0,
        top: show ? '45%' : '40%'
      }}
      dangerouslySetInnerHTML={{ __html: message }}
    />
  );
};

export default Toast;